import { useEffect, useLayoutEffect, useRef } from "react";
import { animate, useInView, useReducedMotion } from "framer-motion";

export const fmtInt = (v) => Math.round(v).toLocaleString("en-GB");

// Count-up number. Text is written directly to the DOM so re-renders never interrupt the animation.
export function AnimatedNumber({ value, format = fmtInt, duration = 1.4, delay = 0, startOnView = false, className, ...rest }) {
  const ref = useRef(null);
  const current = useRef(0);
  const reduce = useReducedMotion();
  const inView = useInView(ref, { once: true, margin: "-8% 0px" });
  const fmt = useRef(format);
  fmt.current = format;

  useLayoutEffect(() => {
    if (ref.current) ref.current.textContent = fmt.current(current.current);
  }, []);

  useEffect(() => {
    const node = ref.current;
    if (!node || (startOnView && !inView)) return undefined;
    if (reduce) {
      current.current = value;
      node.textContent = fmt.current(value);
      return undefined;
    }
    const controls = animate(current.current, value, {
      duration,
      delay,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => {
        current.current = v;
        node.textContent = fmt.current(v);
      },
    });
    return () => controls.stop();
  }, [value, inView, startOnView, reduce, duration, delay]);

  return <span ref={ref} className={className} {...rest} />;
}
